import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
  Input
} from '@angular/core';
import { FullCalendarComponent, FullCalendarModule } from '@fullcalendar/angular';
import {
  CalendarOptions,
  DateSelectArg,
  EventClickArg,
  EventDropArg,
  EventInput,
  // EventResizeArg,
  Calendar
} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import { EventDialogCalendarComponentComponent } from '../event-dialog-calendar-component/event-dialog-calendar-component.component';
import { EventoAgendaService } from '@services/eventoAgenda/eventoAgenda.service';
import { MatDialog, MatDialogConfig, MatDialogContent, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import esLocale from '@fullcalendar/core/locales/es';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ButtonCloseDialogComponent } from '../../button-close-dialog/button-close-dialog.component';
import { ButtonNewComponent } from '../../button-new/button-new.component';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { SinDatosParaMostrarComponent } from '../../sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { Overlay, OverlayModule, OverlayPositionBuilder, OverlayRef } from '@angular/cdk/overlay';
import { PortalModule, TemplatePortal } from '@angular/cdk/portal';
import { EventoAgendaDto } from '@models/eventoAgenda/eventoAgendaDto.model';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { AccionesDialog, TiposEventos } from '@models/base/identificadores.model';
import { Subject, takeUntil, finalize, catchError, of, tap, Observable, forkJoin, debounceTime, distinctUntilChanged, retry, retryWhen, delay, take } from 'rxjs';
import { ButtonFilterTableClearComponent } from '@component/button-filter-table-clear/button-filter-table-clear.component';
import { ButtonFilterTableComponent } from '@component/button-filter-table/button-filter-table.component';
import { EventoAgendaFilter } from '@models/eventoAgenda/eventoAgendaFilter.model';
import { DialogParams } from '@interfaces/dialogParam.interface.model';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonActionComponent } from '@component/button-action/button-action.component';
import { StatusBadgeComponent } from '@component/status-badge/status-badge.component';
import { BtnNuevoUsuarioComponent } from '@views/usuarios/btn-nuevo-usuario/btn-nuevo-usuario.component';
import { SelectionModel } from '@angular/cdk/collections';
import { MatChipsModule } from '@angular/material/chips';
import { UpdateEventoAgendaRequest } from '@models/eventoAgenda/updateEventoAgendaRequest.model';
import { LoginService } from '@services/login/login.service';
import { UsuarioDto } from '@models/usuario/usuarioDto.model';
import { EstadoEventoAgendaService } from '@services/estadoEventoAgenda/estadoEventoAgenda.service';
import { TipoEventoAgendaService } from '@services/tipoEventoAgenda/tipoEventoAgenda.service';
import { BaseDto } from '@models/base/baseDto.model';
import { Router } from '@angular/router';

// Interfaces
interface SlideToggleEvent {
  checked: boolean;
  source: MatSlideToggleChange;
}

interface FilterChangeEvent extends SlideToggleEvent {
  filterType: 'advanced' | 'company' | 'table' | 'filters';
}

interface ApiError {
  status: number;
  error?: {
    message?: string;
  };
  message?: string;
}

// Constants
const SPINNER_NAMES = {
  TIPOS_EVENTO: 'spTiposEventoAgenda',
  ESTADOS_EVENTO: 'spEstadoEventoAgenda',
  EVENTO_DIALOG: 'spEventoDialogCalendar',
} as const;

const RETRY_CONFIG = {
  maxRetries: 3,
  retryDelay: 1000,
} as const;

@Component({
  selector: 'app-general-calendar',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FullCalendarModule,
    NgxSpinnerModule,
    ButtonCloseDialogComponent,
    ButtonNewComponent,
    // Angular Material modules
    MatDialogModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatButtonModule,
    MatChipsModule,
    MatDividerModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatTableModule,
    MatMenuModule,
    SinDatosParaMostrarComponent,
    OverlayModule,
    PortalModule,
    MatPaginator,
    MatSort,
    MatDialogContent,
    ButtonFilterTableClearComponent,
    ButtonFilterTableComponent,
    ButtonNewComponent,
    AppRolesDirective,
    MatButtonModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    StatusBadgeComponent,
    ButtonActionComponent,
    MatTooltipModule,
    MatNativeDateModule,
  ],
  templateUrl: 'general-calendar.component.html',
  styleUrl: './general-calendar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeneralCalendarComponent implements OnInit, OnDestroy, AfterViewInit {


  // ViewChild references
  @ViewChild('calendarRef') calendarComponent!: FullCalendarComponent;
  @ViewChild('eventOverlay') eventOverlay!: TemplateRef<any>;
  @ViewChild('table') table!: MatTable<EventoAgendaDto>;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('sort') sort!: MatSort;
  @Input() idExpediente!: number

  // Properties
  dataSource = new MatTableDataSource<EventoAgendaDto>();
  displayedColumns: string[] = [];


  calendarOptions: CalendarOptions = {
    plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
    themeSystem: 'bootstrap5',
    initialView: 'dayGridMonth',
    locale: esLocale,
    height: 'auto',
    aspectRatio: 1.8,
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
    },
    buttonText: {
      today: 'Hoy',
      month: 'Mes',
      week: 'Semana',
      day: 'Día',
      list: 'Lista'
    },
    events: [],
    editable: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: true,
    weekends: true,
    dragScroll: true,
    eventDurationEditable: true,
    select: this.onSelectDate.bind(this),
    eventClick: this.onEventClick.bind(this),
    eventDrop: this.onEventDrop.bind(this),
    // eventResize: this.onEventResize.bind(this),
    eventDidMount: this.onEventDidMount.bind(this),
    loading: this.onCalendarLoading.bind(this),
    eventContent: this.renderEventContent.bind(this),
  };

  // State properties
  loading = false;
  error = '';
  isOpen = false;
  eventId!: number;
  hasData = false;
  showTableView = false;


  accionesDialog = AccionesDialog;
  tiposEventos = TiposEventos
  formBuilder = new FormBuilder
  formFilter!: FormGroup;
  data = false

  selection = new SelectionModel<any>(true, []); // true para selección múltiple
  // Private properties
  private destroy$ = new Subject<void>();
  private overlayRef: OverlayRef | null = null;
  checkedFiltroAvanzado!: boolean;
  checkedEsVistaTabla!: boolean;
  checkedEsEventosEmpresa!: boolean;
  usuarioDto!: UsuarioDto;
  checkedFiltro!: boolean;
  listaTiposEvento!:BaseDto[] | never[];
  estadosEventoAgenda!:BaseDto[] | never[];


  // Setters for ViewChild with delayed initialization
  @ViewChild(MatSort) set matSort(ms: MatSort) {
    if (ms) {
      this.sort = ms;
      this.setDataSourceAttributes();
    }
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    if (mp) {
      this.paginator = mp;
      this.setDataSourceAttributes();
    }
  }



  constructor(
    private eventoAgendaService: EventoAgendaService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private snackBar: SnackBarService,
    private overlay: Overlay,
    private loginService: LoginService,
    private viewContainerRef: ViewContainerRef,
    private readonly tipoEventoAgendaService: TipoEventoAgendaService,
        private readonly estadoEventoAgendaService: EstadoEventoAgendaService,
    private positionBuilder: OverlayPositionBuilder,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
  ) {

    this.formFilter = this.formBuilder.group({
      Titulo: [null],
      IdExpediente: [null],
      AsignadoA: [null],
      CreadoPor: [null],
      ModificadoPor: [null],
      FechaAltaDesde: [null],
      FechaAltaHasta: [null],
      IdsEstadoEvento: [null],
      IdsTipoEvento: [null],
    });

    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ["select", "titulo", "accion"] :
        ["select", "titulo", "fechaInicio", "fechaFin", "tipoEventoAgenda", "estadoEventoAgenda", "estados", "accion"];
    });

    if(this.idExpediente)
      this.formFilter.controls['IdExpediente'].setValue(this.idExpediente);
  }

  ngOnInit(): void {
    this.initializeComponent();
    this.loadInitialData()
    this.usuarioDto = this.loginService.getCurrentUser();
  }

  iniciaFiltroTabla() {
    // this.dataSource.filterPredicate = (data: any, filter: string) => {
    //   const search = filter.trim().toLowerCase();
    //   return (
    //     data.usuario?.userName?.toLowerCase().includes(search) ||
    //     data.usuario?.nombre?.toLowerCase().includes(search) ||
    //     data.usuario?.apellido?.toLowerCase().includes(search) ||
    //     data.usuario?.correo?.toLowerCase().includes(search) ||
    //     data.rol?.descripcion?.toLowerCase().includes(search)
    //   );
    // }
  }

   private loadInitialData(): void {
      const tiposEventoSpinner = this.spinner.show(SPINNER_NAMES.TIPOS_EVENTO);
      const estadosEventoSpinner = this.spinner.show(SPINNER_NAMES.ESTADOS_EVENTO);

      forkJoin({
        tiposEvento: this.tipoEventoAgendaService.getAll(),
        estadosEvento: this.estadoEventoAgendaService.getAll()
      }).pipe(
        takeUntil(this.destroy$),
        catchError(error => {
          this.snackBar.showError(error, 'Error al cargar datos iniciales');
          return of({ tiposEvento: [], estadosEvento: [] });
        }),
        finalize(() => {
          this.spinner.hide(SPINNER_NAMES.TIPOS_EVENTO);
          this.spinner.hide(SPINNER_NAMES.ESTADOS_EVENTO);
        })
      ).subscribe({
        next: ({ tiposEvento, estadosEvento }) => {
          this.listaTiposEvento = tiposEvento;
          this.estadosEventoAgenda = estadosEvento;
        }
      });
    }

    getStatusIcon(status?: string): string {
    if (!status) return 'help';

    const statusLower = status.toLowerCase();
    if (statusLower.includes('completado') || statusLower.includes('finalizado')) return 'check_circle';
    if (statusLower.includes('cancelado')) return 'cancel';
    if (statusLower.includes('activo') || statusLower.includes('en curso')) return 'play_circle';
    if (statusLower.includes('pendiente')) return 'schedule';
    return 'help';
  }

  // Selecciona o deselecciona todos
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource.data);
  }

  // Selecciona una fila individual
  toggleRow(row: any) {
    this.selection.toggle(row);
  }

  // Acciones generales
  accionGeneral(accion: string) {
    const seleccionados = this.selection.selected;
    console.log('Acción:', accion, 'Elementos seleccionados:', seleccionados);

    seleccionados.forEach(item => { });
  }

  guardarFiltro() {
    const filtro: EventoAgendaFilter = this.formFilter.value;
    localStorage.setItem('filtroUsuarioEmpresaGuardado', JSON.stringify(filtro));
  }

  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroUsuarioEmpresaGuardado');
  }

  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false
  }

   checkfiltros(event: any) {
    if (event.checked == true)
      this.checkedFiltro = true
    else
      this.checkedFiltro = false
  }

  esEventosEmpresa(event: any) {
    if (event.checked == true)
    {
      this.checkedEsEventosEmpresa = true
      this.formFilter.controls['CreadoPor'].setValue(null);
    }
    else
    {
      this.checkedEsEventosEmpresa = false
      this.formFilter.controls['CreadoPor'].setValue(this.usuarioDto.id);
    }
    this.aplicarFiltro();
  }

  vistaTabla(event: any) {
    if (event.checked == true)
      this.checkedEsVistaTabla = true
    else
      this.checkedEsVistaTabla = false
  }

  aplicarFiltro(filtro: EventoAgendaFilter = this.formFilter.value) {
    this.getEventsByCustomFilterAsync(filtro);
    this.guardarFiltro();
  }

  openDialog<T>(params: DialogParams<T> & { tipoEvento?: any }) {
    const { accion, entidad, tipoEvento } = params;

    // Configurar el objeto data según la acción
    let data: any = {
      idExpediente: this.idExpediente,
      start: new Date(),
      end: new Date(),
      item: entidad || {},
      esNuevo: false,
      esVista: false,
      esEditar: false,
      esEliminar: false
    };

    // Configurar las propiedades según la acción
    switch (accion) {
      case AccionesDialog.Agregar:
        data.esNuevo = true;
        if (tipoEvento) {
          data.tipoEvento = tipoEvento;
        }
        break;
      case AccionesDialog.Ver:
        data.esVista = true;
        break;
      case AccionesDialog.Modificar:
        data.esEditar = true;
        break;
      case AccionesDialog.Eliminar:
        data.esEliminar = true;
        break;
    }

    this.openEventDialog(data).subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.getByIdAndAddToCalendar(result.data?.id);
          break;
        case AccionesDialog.Modificar:
          this.handleEventDialogResult(result.data);
          break;
        case AccionesDialog.Eliminar:
          this.handleEventDialogResult(result.data);
          break;
        default:
          break;
      }
    });
  }


  openEventDialog(data: any, width: string = '80%'): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.disableClose = true;
    dialogConfig.data = data;
    dialogConfig.width = width;
    dialogConfig.height = '80%';

    const dialogRef = this.dialog.open(EventDialogCalendarComponentComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(takeUntil(this.destroy$));
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = (data: any, filter: string) => {
      let searchTerms = JSON.parse(filter);
      return data.name.toLowerCase().indexOf(searchTerms.userName) !== -1
        && data.estado.toString().toLowerCase().indexOf(searchTerms.activo) !== -1
    }
    return filterFunction;
  }

  sortingDataAccessor() {
    // this.dataSource.sortingDataAccessor = (item: any, property: string) => {
    //   switch (property) {
    //     case 'userName':
    //       return item.usuario?.userName?.toLowerCase() || '';
    //     case 'nombreCompleto':
    //       return `${item.usuario?.nombre || ''} ${item.usuario?.apellido || ''}`.toLowerCase();
    //     case 'correo':
    //       return item.usuario?.correo?.toLowerCase() || '';
    //     case 'rol':
    //       return item.rol?.descripcion?.toLowerCase() || '';
    //     case 'estado':
    //       return item.activo ? 1 : 0; // o true/false si querés mantener orden booleando
    //     default:
    //       return item[property];
    //   }
    // };
  }



  /**
 * Aplica filtro a la tabla
 */
  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngAfterViewInit(): void {
    this.setDataSourceAttributes();
    this.refreshCalendar();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.closeOverlay();
  }

  /**
   * Inicializa el componente cargando los eventos
   */
  private initializeComponent(): void {
    this.aplicarFiltro()
  }

  /**
   * Configura los atributos del dataSource una vez que están disponibles
   */
  private setDataSourceAttributes(): void {
    if (this.dataSource) {
      if (this.sort) {
        this.dataSource.sort = this.sort;
      }
      if (this.paginator) {
        this.dataSource.paginator = this.paginator;
      }
    }
  }



  /**
   * Carga todos los eventos desde el servicio
   */
  getAll(): void {
    this.setLoadingState(true);
    this.error = '';

    this.eventoAgendaService.getAll()
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.spinner.show("spLoadCalendar")),
        catchError(error => {
          this.handleError('Ocurrió un error al cargar los eventos.', error);
          return of([]);
        }),
        finalize(() => {
          this.spinner.hide("spLoadCalendar");
          this.setLoadingState(false);
        })
      )
      .subscribe(data => {
        this.processEventosData(data);
      });
  }

  getEventsByCustomFilterAsync(filtro: EventoAgendaFilter): void {
    this.setLoadingState(true);
    this.error = '';

    this.eventoAgendaService.getEventsByCustomFilterAsync(filtro)
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.spinner.show("spLoadCalendar")),
        catchError(error => {
          this.handleError('Ocurrió un error al cargar los eventos.', error);
          return of([]);
        }),
        finalize(() => {
          this.spinner.hide("spLoadCalendar");
          this.setLoadingState(false);
        })
      )
      .subscribe(data => {
        this.processEventosData(data);
        this.data = this.dataSource.data.length >= 1 ? true : false
      });
  }

  getByUserIdAsync(idUsuario: number): void {
    this.setLoadingState(true);
    this.error = '';

    this.eventoAgendaService.getByUserIdAsync(0)
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.spinner.show("spLoadCalendar")),
        catchError(error => {
          this.handleError('Ocurrió un error al cargar los eventos.', error);
          return of([]);
        }),
        finalize(() => {
          this.spinner.hide("spLoadCalendar");
          this.setLoadingState(false);
        })
      )
      .subscribe(data => {
        this.processEventosData(data);
        this.data = this.dataSource.data.length >= 1 ? true : false
      });
  }

  /**
   * Procesa los datos de eventos recibidos
   */
  private processEventosData(data: EventoAgendaDto[]): void {
    this.dataSource.data = data;
    this.hasData = data.length > 0;

    const eventosMapeados = data.map(evento => this.mapEventoToEventInput(evento));

    this.calendarOptions = {
      ...this.calendarOptions,
      events: eventosMapeados
    };

    this.refreshCalendar();
    this.cdr.markForCheck();
  }

  /**
   * Refresca el calendario después de cambios
   */
  private refreshCalendar(): void {
    setTimeout(() => {
      if (this.calendarComponent?.getApi) {
        const api = this.calendarComponent.getApi();
        api.updateSize();
        api.render();
        api.refetchEvents();
      }
    }, 0);
  }

  /**
   * Mapea un EventoAgendaDto a EventInput para FullCalendar
   */
  private mapEventoToEventInput(evento: EventoAgendaDto): EventInput {
    if (!evento) {
      console.warn('Evento nulo o indefinido recibido en mapEventoToEventInput');
      return {};
    }

    return {
      id: evento.id?.toString() ?? '',
      title: evento.titulo ?? 'Sin título',
      start: evento.fechaInicio ?? new Date(),
      end: evento.fechaFin ?? undefined,
      allDay: evento.esTodoElDia ?? false,
      backgroundColor: evento.colorFondo ?? this.getColorPorDescripcion(evento.tipoEventoAgenda?.descripcion),
      borderColor: evento.colorBorde ?? this.getColorPorDescripcion(evento.tipoEventoAgenda?.descripcion),
      textColor: evento.colorTexto ?? '#ffffff',
      className: this.parseClassNames(evento.classNames),
      editable: evento.esEditable ?? true,
      extendedProps: {
        descripcion: evento.descripcion ?? '',
        comentarios: evento.comentarios ?? '',
        lugar: evento.lugar ?? '',
        expediente: evento.expediente ?? null,
        prioridad: evento.prioridad ?? null,
        nivelAvance: evento.nivelAvance ?? null,
        tipoEvento: evento.tipoEventoAgenda?.descripcion ?? '',
        estado: evento.estadoEventoAgenda?.descripcion ?? '',
        avisoNMinutosAntes: evento.avisoNMinutosAntes ?? null,
        observaciones: evento.observaciones ?? '',
        diasSemana: evento.diasSemana ?? '',
        unidadRepeticion: evento.unidadRepeticion ?? '',
        esEventoPresencial: evento.esEventoPresencial ?? false,
        zonaHoraria: evento.zonaHoraria ?? 'America/Argentina/Buenos_Aires'
      }
    };
  }

  /**
   * Parsea los nombres de clase de string a array
   */
  private parseClassNames(classNames?: string): string[] {
    if (!classNames) return [];
    return classNames.split(' ').filter(className => className.trim().length > 0);
  }

  /**
   * Obtiene color basado en la descripción del tipo de evento
   */
  getColorPorDescripcion(descripcion?: string): string {
    if (!descripcion || typeof descripcion !== 'string') {
      return '#D7D7D7'; // gris por defecto
    }

    // const colorMap: { [key: string]: string } = {
    //   'capacitación': '#4a90e2',           // Azul suave
    //   'entrega de documentación': '#17a2b8', // Celeste petróleo
    //   'llamado telefónico': '#5cb85c',     // Verde apagado
    //   'videollamada': '#f0ad4e',           // Amarillo suave
    //   'audiencia': '#d9534f',              // Rojo bordó
    //   'importante': '#f38b2b',             // Naranja tostado
    //   'personal': '#7b68ee',               // Violeta apagado
    //   'consulta': '#20c997',               // Verde menta
    //   'otro': '#6c757d',                   // Gris neutro
    //   'pericia': '#e83e8c'                 // Rosa fuerte
    // };

    // return colorMap[descripcion.toLowerCase()] ?? '#6c757d';
    return '#D7D7D7'; // gris por defecto
  }

  /**
   * Maneja la selección de fecha en el calendario
   */
  onSelectDate(selectInfo: DateSelectArg): void {
    const data = {
      start: selectInfo.start,
      end: selectInfo.end,
      esNuevo: true,
      item: {},
      idExpediente: this.idExpediente,
      accion: AccionesDialog.Agregar
    };


    this.openEventDialog(data).subscribe(result => {
      this.calendarComponent.getApi().unselect();
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          // this.aplicarFiltro();
          this.getByIdAndAddToCalendar(result.data?.id);
          break;
        case AccionesDialog.Modificar:
          // this.aplicarFiltro();
          this.handleEventDialogResult(result.data);
          break;
        case AccionesDialog.Eliminar:
          this.handleEventDialogResult(result.data);
          // this.aplicarFiltro();
          break;
        default:
          break;
      }
    });
  }




  /**
   * Obtiene un evento por ID y lo añade al calendario
   */
  getByIdAndAddToCalendar(id: number): void {
    this.spinner.show("spLoadCalendar");

    this.eventoAgendaService.getById(id)
      .pipe(
        takeUntil(this.destroy$),
        catchError(error => {
          this.handleError('Error al cargar el nuevo evento.', error);
          return of(null);
        }),
        finalize(() => this.spinner.hide("spLoadCalendar"))
      )
      .subscribe(evento => {
        if (evento) {
          this.addEventToCalendarAndTable(evento);
        }
      });
  }

  /**
   * Añade un evento al calendario y a la tabla
   */
  private addEventToCalendarAndTable(evento: EventoAgendaDto): void {
    // Añadir a la tabla
    const currentData = [...this.dataSource.data];
    currentData.push(evento);
    this.dataSource.data = currentData;
    this.hasData = true;

    // Añadir al calendario
    const eventoMapeado = this.mapEventoToEventInput(evento);
    const api = this.calendarComponent?.getApi();
    api?.addEvent(eventoMapeado);

    this.cdr.markForCheck();
  }

  /**
   * Maneja el click en un evento del calendario
   */
  onEventClick(clickInfo: EventClickArg): void {
    const selectedEvent = clickInfo.event;
    this.eventId = parseInt(selectedEvent.id);

    if (isNaN(this.eventId)) {
      this.snackBar.showError('ID de evento inválido', 'Error');
      return;
    }

    const item = new EventoAgendaDto();
    item.id = this.eventId;

    const data = {
      item: { ...item },
      esVista: true
    };

    // this.openEventDialog(data, '70%').subscribe((result: any) => {
    //   this.handleEventDialogResult(result);
    // });

    this.openEventDialog(data).subscribe(result => {
      this.calendarComponent.getApi().unselect();
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.aplicarFiltro();
          this.getByIdAndAddToCalendar(result.data?.id);
          break;
        case AccionesDialog.Modificar:
          this.aplicarFiltro();
          this.handleEventDialogResult(result.data);
          break;
        case AccionesDialog.Eliminar:
          this.handleEventDialogResult(result.data);
          this.aplicarFiltro();
          break;
        default:
          break;
      }
      this.handleEventDialogResult(result);
    });
  }

  getReminderIcon(minutesBefore: number): string {
    if (minutesBefore >= 10080) { // 1 semana o más
      return 'event_note'; // 📅 evento programado a largo plazo
    } else if (minutesBefore >= 1440) { // 1 día o más
      return 'today'; // 📆 aviso anticipado de día completo
    } else if (minutesBefore >= 120) { // 2 horas o más
      return 'alarm'; // ⏰ alerta importante
    } else if (minutesBefore >= 20) { // más de 20 minutos
      return 'notifications'; // 🔔 notificación clásica
    } else if (minutesBefore > 0) { // menos de 20 minutos
      return 'notification_important'; // 🚨 alerta inmediata
    } else {
      return ''; // sin aviso
    }
  }

  /**
   * Maneja el resultado del diálogo de evento
   */
  private handleEventDialogResult(result: any): void {
    if (!result) return;

    switch (result.accion) {
      case AccionesDialog.Eliminar:
        this.eliminarEventoDeCalendario(this.eventId.toString());
        this.removeEventFromTable(this.eventId);
        break;
      case AccionesDialog.Modificar:
        this.modificarEventoDeCalendario(this.eventId.toString(), result.data);
        this.updateEventInTable(this.eventId, result.data);
        break;
    }
  }

  /**
   * Elimina un evento del calendario
   */
  eliminarEventoDeCalendario(id: string): void {
    const calendarApi = this.calendarComponent.getApi();
    const event = calendarApi.getEventById(id);
    if (event) {
      event.remove();
    }
  }

  /**
   * Elimina un evento de la tabla
   */
  private removeEventFromTable(id: number): void {
    const currentData = this.dataSource.data.filter(evento => evento.id !== id);
    this.dataSource.data = currentData;
    this.hasData = currentData.length > 0;
    this.cdr.markForCheck();
  }

  /**
   * Modifica un evento en el calendario
   */
  modificarEventoDeCalendario(id: string, nuevosDatos: any): void {
    const calendarApi = this.calendarComponent.getApi();
    const event = calendarApi.getEventById(id);

    if (event && nuevosDatos) {
      if (nuevosDatos.title) event.setProp('title', nuevosDatos.title);
      if (nuevosDatos.start) event.setStart(nuevosDatos.start);
      if (nuevosDatos.end) event.setEnd(nuevosDatos.end);
      if (nuevosDatos.backgroundColor) event.setProp('backgroundColor', nuevosDatos.backgroundColor);
      if (nuevosDatos.borderColor) event.setProp('borderColor', nuevosDatos.borderColor);
    }
  }

  /**
   * Actualiza un evento en la tabla
   */
  private updateEventInTable(id: number, nuevosDatos: any): void {
    const currentData = [...this.dataSource.data];
    const index = currentData.findIndex(evento => evento.id === id);

    if (index !== -1 && nuevosDatos) {
      currentData[index] = { ...currentData[index], ...nuevosDatos };
      this.dataSource.data = currentData;
      this.cdr.markForCheck();
    }
  }

  /**
   * Maneja el arrastrar y soltar eventos
   */
  onEventDrop(dropInfo: EventDropArg): void {
    const evento = dropInfo.event;
    const updateData = {
      id: parseInt(evento.id),
      fechaInicio: evento.start,
      fechaFin: evento.end,
      titulo: evento.title
    };

    let updateEventoAgendaRequest: UpdateEventoAgendaRequest = new UpdateEventoAgendaRequest
    updateEventoAgendaRequest.id = updateData.id
    updateEventoAgendaRequest.fechaInicio = updateData.fechaInicio instanceof Date
      ? updateData.fechaInicio.toISOString()
      : (updateData.fechaInicio ? String(updateData.fechaInicio) : '');

    this.update(updateEventoAgendaRequest)
    this.updateEventInTable(updateData.id, updateData);
  }

  update(updateEventoAgendaRequest: UpdateEventoAgendaRequest): void {
    this.spinner.show('spLoadCalendar')
    this.eventoAgendaService.update(updateEventoAgendaRequest)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.spinner.hide('spLoadCalendar'))
      )
      .subscribe({
        next: (data) => {
          this.snackBar.showSuccess('Evento actualizado exitosamente.', 'Éxito');
        },
        error: (error) => {
          this.snackBar.showError(error, 'Error al actualizar el evento.');
        }
      });
  }

  /**
   * Maneja el redimensionar eventos
   */
  // onEventResize(resizeInfo: EventResizeArg): void {
  //   const evento = resizeInfo.event;
  //   const updateData = {
  //     id: parseInt(evento.id),
  //     fechaInicio: evento.start,
  //     fechaFin: evento.end
  //   };

  //   // Aquí podrías llamar al servicio para actualizar en el backend
  //   // this.eventoAgendaService.update(updateData).subscribe(...)

  //   this.updateEventInTable(updateData.id, updateData);
  // }

  /**
   * Se ejecuta cuando un evento se monta en el DOM
   */
  onEventDidMount(info: any): void {
    // Añadir tooltip o personalización adicional si es necesario
    if (info.event.extendedProps.descripcion) {
      info.el.setAttribute('title', info.event.extendedProps.descripcion);
    }
  }
  renderEventContent(arg: any) {
    const evento = arg.event.extendedProps;

    // Construir el contenido del tooltip
    const tooltipContent = this.buildTooltipContent(arg.event, evento);

    return {
      html: `
      <div class="fc-event-custom ${evento.type || ''}">
        <div class="event-header">
          <div class="event-title">
            <strong>${arg.event.title.substring(0, 25)}${arg.event.title.length > 25 ? '...' : ''}</strong>
          </div>
        </div>
      </div>
    `
    };
  }

  private buildTooltipContent(event: any, evento: any): string {
    const isAllDay = event.allDay;
    const startTime = event.start ? event.start.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit'
    }) : '';
    const endTime = event.end ? event.end.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit'
    }) : '';

    let tooltip = `<div class="event-tooltip">`;
    tooltip += `<div class="tooltip-title">${event.title}</div>`;

    // Fecha y hora
    tooltip += `<div class="tooltip-section">`;
    tooltip += `<strong>📅 Fecha:</strong> ${event.start.toLocaleDateString('es-ES', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}`;

    if (!isAllDay && startTime) {
      tooltip += `<br><strong>⏰ Horario:</strong> ${startTime}${endTime ? ` - ${endTime}` : ''}`;
    } else if (isAllDay) {
      tooltip += `<br><strong>⏰ Duración:</strong> Todo el día`;
    }
    tooltip += `</div>`;

    // Tipo y estado
    if (evento.tipo || evento.estado) {
      tooltip += `<div class="tooltip-section">`;
      if (evento.tipo) tooltip += `<strong>🏷️ Tipo:</strong> ${evento.tipo}<br>`;
      if (evento.estado) tooltip += `<strong>📊 Estado:</strong> ${evento.estado}`;
      tooltip += `</div>`;
    }

    // Ubicación
    if (evento.lugar) {
      tooltip += `<div class="tooltip-section">`;
      tooltip += `<strong>📍 Lugar:</strong> ${evento.lugar}`;
      if (evento.esEventoPresencial === false && evento.url) {
        tooltip += `<br><strong>💻 Reunión:</strong> <a href="${evento.url}" target="_blank">Enlace virtual</a>`;
      } else if (evento.esEventoPresencial) {
        tooltip += ` (Presencial)`;
      }
      tooltip += `</div>`;
    }

    // Prioridad
    if (evento.prioridad && evento.prioridad > 2) {
      tooltip += `<div class="tooltip-section">`;
      tooltip += `<strong>⚠️ Prioridad:</strong> ${evento.prioridad === 4 ? 'Crítica' : 'Alta'}`;
      tooltip += `</div>`;
    }

    // Recordatorio
    if (evento.avisoNMinutosAntes && evento.avisoNMinutosAntes > 0) {
      tooltip += `<div class="tooltip-section">`;
      tooltip += `<strong>🔔 Recordatorio:</strong> ${evento.avisoNMinutosAntes} min antes`;
      tooltip += `</div>`;
    }

    // Expediente
    if (evento.expediente) {
      tooltip += `<div class="tooltip-section">`;
      tooltip += `<strong>📁 Expediente:</strong> #${evento.expediente.numero || evento.expediente.id}`;
      tooltip += `</div>`;
    }

    // Observaciones
    if (evento.observaciones) {
      tooltip += `<div class="tooltip-section">`;
      tooltip += `<strong>📝 Observaciones:</strong><br>${evento.observaciones.substring(0, 100)}${evento.observaciones.length > 100 ? '...' : ''}`;
      tooltip += `</div>`;
    }

    // Información de creación
    if (evento.creadoPor || evento.fechaAlta) {
      tooltip += `<div class="tooltip-section tooltip-meta">`;
      if (evento.fechaAlta) {
        tooltip += `<strong>📅 Creado:</strong> ${new Date(evento.fechaAlta).toLocaleDateString('es-ES')}`;
      }
      if (evento.creadoPor) {
        tooltip += `<br><strong>👤 Por:</strong> ${evento.creadoPor.nombre} ${evento.creadoPor.apellido}`;
      }
      tooltip += `</div>`;
    }

    tooltip += `</div>`;
    return tooltip;
  }


  /**
   * Maneja el estado de carga del calendario
   */
  onCalendarLoading(isLoading: boolean): void {
    if (isLoading) {
      this.spinner.show("spLoadCalendar");
    } else {
      this.spinner.hide("spLoadCalendar");
    }
  }

  /**
   * Establece el estado de carga
   */
  private setLoadingState(loading: boolean): void {
    this.loading = loading;
    this.cdr.markForCheck();
  }

  /**
   * Maneja errores de manera consistente
   */
  private handleError(message: string, error: any): void {
    console.error('Error en GeneralCalendarComponent:', error);
    this.error = message;
    this.snackBar.showError(error, "Error");
    this.cdr.markForCheck();
  }

  /**
   * Cierra el overlay si está abierto
   */
  private closeOverlay(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  // Métodos placeholder para completar funcionalidad
  nuevoEventoAudiencia(): void {
    // Implementar según necesidades específicas
    console.log('Nuevo evento de audiencia');
  }

  nuevoEventoPrueba(): void {
    // Implementar según necesidades específicas
    console.log('Nuevo evento de prueba');
  }

  /**
   * Alterna entre vista de calendario y tabla
   */
  toggleView(event: any): void {
    this.showTableView = !event.checked;
    this.cdr.markForCheck();
  }

  /**
   * Obtiene color del chip según el estado
   */
  getChipColorByState(estado?: string): string {
    if (!estado) return '#6c757d'; // Gris por defecto

    const stateColors: { [key: string]: string } = {
      'pendiente': '#ffc107', // Amarillo suave
      'confirmado': '#17a2b8', // Celeste petróleo
      'en curso': '#007bff', // Azul
      'reprogramado': '#fd7e14', // Naranja tostado
      'cancelado': '#dc3545', // Rojo bordó
      'finalizado': '#6f42c1', // Verde oscuro
      'no asistido': '#28a745', // Violeta apagado
      'suspendido temporalmente': '#6c757a' // Gris neutro
    };

    return stateColors[estado.toLowerCase()] || '#6c757d'; // Gris si no está definido
  }

  /**
   * Edita un evento desde la tabla
   */
  editarEvento(evento: EventoAgendaDto): void {
    const dialogRef = this.dialog.open(EventDialogCalendarComponentComponent, {
      width: '70%',
      maxWidth: '800px',
      data: {
        item: evento,
        esVista: false,
        esEdicion: true
      },
      disableClose: true
    });

    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: any) => {
        if (result?.accion === AccionesDialog.Modificar) {
          this.updateEventInTable(evento.id!, result.data);
          this.modificarEventoDeCalendario(evento.id!.toString(), result.data);
        }
      });
  }

  /**
   * Elimina un evento desde la tabla
   */
  eliminarEvento(evento: EventoAgendaDto): void {
    // Aquí podrías mostrar un diálogo de confirmación
    if (confirm(`¿Está seguro de que desea eliminar el evento "${evento.titulo}"?`)) {
      this.eliminarEventoDeCalendario(evento.id!.toString());
      this.removeEventFromTable(evento.id!);
      this.snackBar.showSuccess('Evento eliminado correctamente', 'Éxito');
    }
  }

  /**
   * Función trackBy para optimizar el rendimiento de *ngFor
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
